import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, timestampToDateForInput } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdAdd, MdCheck, MdClose, MdDelete, MdDeleteOutline, MdSms, MdWhatsapp } from "react-icons/md";

export default function View({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const itemTemplate = {
		name: '',
		quantity: 1,
		amount: 0,
		subTotal: 0,
	};

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [dateDueString, setDateDueString] = useState("");
	const [applicableTo, setApplicableTo] = useState("classrooms");
	const [applicableClassrooms, setApplicableClassrooms] = useState([""]);
	const [applicableStreams, setApplicableStreams] = useState([""]);
	const [items, setItems] = useState([itemTemplate])
	const [totalAmount, setTotalAmount] = useState(0);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllClassrooms(),
			appContext.getAllStreams(),
		])
		setReady(true);
	}

	function addApplicable(setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new.push("");

			return _new;
		})
	}

	function handleApplicableChange(index, value, setter) {
		if(value === 'all') {
			if(appContext.allClassrooms && appContext.allClassrooms.length > 0) {
				const _all = appContext.allClassrooms.map((item) => {
					return item.uuid;
				});

				setApplicableClassrooms(_all);
			}
			
		} else {
			setter(_prev => {
				const _new = [..._prev];

				_new[index] = value;

				return _new;
			})
		}
	}

	function deleteApplicable(index, setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1)

			return _new;
		})
	}

	function cleanApplicables(_raw) {
		const _cleaned = [...new Set(_raw.filter((item, i) => {
			return (item && String(item).trim().length > 0 );
		}))];

		return _cleaned;
	}

	function addItem() {
		setItems(_prev => {
			const _new = [..._prev];

			_new.push(itemTemplate);

			return _new;
		})
	}

	function handleItemChange(index, field, value) {
		setItems(_prev => {
			const _new = [..._prev];

			if(field === 'quantity' || field === 'amount') {
				_new[index][field] =  Number(value) || 0;
			} else {
				_new[index][field] = value;
			}

			//calculate subtotal
			_new[index].subTotal = (Number(_new[index].quantity) * Number(_new[index].amount) ) || 0;

			return _new;
		})
	}

	function deleteItem(index) {
		setItems(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1)

			return _new;
		})
	}

	

	function getTotalAmount() {
		let _total = 0;

		if(items) {
			for (const item of items) {
				_total += Number(item.subTotal);
			}
		}

		setTotalAmount(_total);
	}

	function resetForm() {
		setTitle("");
		setDescription("");
		setDateDueString("");
		setApplicableTo("classroom");
		setApplicableClassrooms([""]);
		setApplicableStreams([""]);
		setItems([itemTemplate]);
	}

	async function create() {
		const _classrooms = cleanApplicables(applicableClassrooms);
		const _streams = cleanApplicables(applicableStreams);

		if(title.trim().length > 0) {
			if(description.trim().length > 0) {
				if(dateDueString.trim().length > 0) {
					if(
						(applicableTo === 'classrooms' && _classrooms && _classrooms.length > 0) ||
						(applicableTo === 'streams' && _streams && _streams.length > 0)
					) {
						if(items && items.length > 0 && Number(totalAmount) > 0) {
							setLoading(true);
							await callApi(
								'create-general-payment-cycle', 
								{
									title,
									description,
									dateDueString,
									applicableTo,
									applicableClassrooms: JSON.stringify(_classrooms),
									applicableStreams: JSON.stringify(_streams),
									items: JSON.stringify(items),
									totalAmount,
									schoolUuid: appContext.currentSchoolUuid,
								}
							).then((response) => {
								if(response.status === 1) {
									appContext.tellMessage("Payment Cycle was created successfully");
									resetForm();
									appContext.getAllGeneralPaymentCycles();
								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError("Invalid items and amount to be paid");
						}
					} else {
						appContext.tellError("Invalid streams or classroom");
					}
				} else {
					appContext.tellError("Invalid due date");
				}
			} else {
				appContext.tellError("Invalid description")
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	async function edit() {
		const _classrooms = cleanApplicables(applicableClassrooms);
		const _streams = cleanApplicables(applicableStreams);

		if(title.trim().length > 0) {
			if(description.trim().length > 0) {
				if(dateDueString.trim().length > 0) {
					if(
						(applicableTo === 'classrooms' && _classrooms && _classrooms.length > 0) ||
						(applicableTo === 'streams' && _streams && _streams.length > 0)
					) {
						if(items && items.length > 0 && Number(totalAmount) > 0) {
							setLoading(true);
							await callApi(
								'edit-general-payment-cycle', 
								{
									uuid: data.uuid,
									title,
									description,
									dateDueString,
									applicableTo,
									applicableClassrooms: JSON.stringify(_classrooms),
									applicableStreams: JSON.stringify(_streams),
									items: JSON.stringify(items),
									totalAmount,
									schoolUuid: appContext.currentSchoolUuid,
								}
							).then((response) => {
								if(response.status === 1) {
									appContext.tellMessage("Payment Cycle was edited successfully");
									resetForm();
									appContext.getAllGeneralPaymentCycles();
									
									if(callback) {
										callback()
									}

								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError("Invalid items and amount to be paid");
						}
					} else {
						appContext.tellError("Invalid streams or classroom");
					}
				} else {
					appContext.tellError("Invalid due date");
				}
			} else {
				appContext.tellError("Invalid description")
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getTotalAmount()
	}, [ items ])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(data) {
			setTitle(data.title);
			setDescription(data.description);
			setApplicableTo(data.applicableTo);
			setApplicableStreams(JSON.parse(data.applicableStreams));
			setApplicableClassrooms(JSON.parse(data.applicableClassrooms));
			setItems(JSON.parse(data.items));
			setTotalAmount(data.totalAmount);
			setDateDueString(timestampToDateForInput(data.dateDue));
		}
	}, [ data ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Title</label>
					<input
						className="form-control"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Description</label>
					<textarea
						className="form-control"
						value={description}
						onChange={e => setDescription(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Due Date</label>
					<input
						className="form-control"
						value={dateDueString}
						type="date"
						onChange={e => setDateDueString(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Applicabe To</label>
					<select
						className="form-control"
						value={applicableTo}
						onChange={e => setApplicableTo(e.target.value)}
					>
						<option value='classrooms'>Classrooms</option>
						<option value='streams'>Streams</option>
					</select>
				</div>

				<div className="col-md-12 mt-2 mb-2" style={{ display: (applicableTo === 'classrooms') ? 'block' : 'none' }}>
					<label className="form-label">Select Applicable Classrooms</label>
					<div 
						className=""
						style={{
							padding: "10px",
							border: "2px solid var(--mutedColor)"
						}}
					>
						<div className="row">
							{
								applicableClassrooms.map((item, i) => {
									return (
										<div key={i} className="col-6 col-md-4">
											<select
												value={item}
												className="form-control mt-2"
												onChange={(e) => {
													handleApplicableChange(i, e.target.value, setApplicableClassrooms)
												}}
											>
												<option value="">Click to select</option>
												<option value="all">All Classrooms</option>
												{
													(appContext.allClassrooms && appContext.allClassrooms.length > 0) ?
													appContext.allClassrooms.map((item, i) => {
														return (
															<option key={i} value={item.uuid}>{item.name}</option>
														)
													})
													:""
												}
											</select>

											<MdDelete
												size={18}
												className="mb-4 text-danger"
												style={{
													cursor: "pointer"
												}}
												onClick={() => {
													deleteApplicable(i, setApplicableClassrooms)
												}}
											/>
										</div>
									)
								})
							}
						</div>

						<button
							className="btn btn-outline-dark btn-sm mt-2"
							onClick={() => {
								addApplicable(setApplicableClassrooms)
							}}
						>
							<MdAdd
							 	size={24}
							 
							/>
						</button>
					</div>
				</div>

				<div className="col-md-12 mt-2 mb-2" style={{ display: (applicableTo === 'streams') ? 'block' : 'none' }}>
					<label className="form-label">Select Applicable Streams</label>
					<div 
						className=""
						style={{
							padding: "10px",
							border: "2px solid var(--mutedColor)"
						}}
					>
						<div className="row">
							{
								applicableStreams.map((item, i) => {
									return (
										<div key={i} className="col-6 col-md-4">
											<select
												value={item}
												className="form-control mt-2"
												onChange={(e) => {
													handleApplicableChange(i, e.target.value, setApplicableStreams)
												}}
											>
												<option value="">Click to select</option>
												{
													(appContext.allStreams && appContext.allStreams.length > 0) ?
													appContext.allStreams.map((item, i) => {
														return (
															<option key={i} value={item.uuid}>{item.name} ({item.classroomName})</option>
														)
													})
													:""
												}
											</select>

											<MdDelete
												size={18}
												className="mb-4 text-danger"
												style={{
													cursor: "pointer"
												}}
												onClick={() => {
													deleteApplicable(i, setApplicableStreams)
												}}
											/>
										</div>
									)
								})
							}
						</div>

						<button
							className="btn btn-outline-dark btn-sm mt-2"
							onClick={() => {
								if(applicableTo === 'classrooms') {
									addApplicable(setApplicableClassrooms)
								} else if(applicableTo === 'streams') {
									addApplicable(setApplicableStreams)
								} 
							}}
						>
							<MdAdd
							  size={24}
							 
							/>
						</button>
					</div>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Items</label>
					<div
						style={{
							width: "100%",
							padding: "10px",
							border: "2px solid var(--mutedColor)"
						}}
					>
						<div
							style={{
								
							}}
						>
							<table
								className="table table-striped"
								style={{
									fontSize: "14px",
								}}
							>
								<thead>
									<tr
										style={{
											fontSize: "12px",
										}}
									>
										<th>Name</th>
										<th>Quantity</th>
										<th>Amount in TZS</th>
										<th>Sub Total in TZS</th>
										<th></th>
									</tr>
								</thead>

								<tbody>
									{
										items.map((item, i) => {
											return (
												<tr key={i}>
													<td>
														<input
															className="form-control"
															value={item.name}
															onChange={(e) => {
																handleItemChange(i, 'name', e.target.value)
															}}
														/>
													</td>

													<td>
														<input
															className="form-control"
															value={item.quantity}
															onChange={(e) => {
																handleItemChange(i, 'quantity', e.target.value)
															}}
														/>
													</td>

													<td>
														<input
															className="form-control"
															value={item.amount}
															onChange={(e) => {
																handleItemChange(i, 'amount', e.target.value)
															}}
														/>
													</td>

													<td style={{ fontSize: "18px" }} className="font-semi-bold">
														{formatMoney(item.subTotal)}
													</td>

													<td
													>
														<MdDelete
															size={18}
															className="text-danger"
															style={{
																cursor: "pointer"
															}}
															onClick={() => {
																deleteItem(i)
															}}
														/>
													</td>
												</tr>
											)
										})
									}

									
								</tbody>
							</table>

							<div className="text-end mt-4">
								<h6
									style={{
										fontSize: "24px"
									}}
									className="font-semi-bold"
								>
									{formatMoney(totalAmount)} TZS
								</h6>
								<h6
									style={{
										fontSize: "18px"
									}}
									className="font-light"
								>
									GRAND TOTAL
								</h6>

								<hr/>
							</div>
						</div>

						<button
							className="btn btn-outline-dark btn-sm mt-2"
							onClick={() => {
								addItem()
							}}
						>
							<MdAdd
							 size={24}
							 
							/>
						</button>

					</div>
					
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Changes you have made will be saved. Continue?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new payment cycle?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}